import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Stepper, 
  Step, 
  StepLabel, 
  StepContent, 
  Paper, 
  Divider,
  Chip,
  Avatar,
  Button
} from '@mui/material';
import { 
  HourglassEmpty, 
  Settings, 
  Verified, 
  DoneAll,
  Close,
  Description 
} from '@mui/icons-material';

const ApplicationStatusTracker = () => {
  const [activeStep, setActiveStep] = useState(1); // Change this to set current status
  const [applicationId] = useState('APP-2023-78945');
  
  const steps = [
    {
      label: 'Pending',
      description: 'Your application has been submitted and is awaiting review',
      icon: <HourglassEmpty />,
      time: '10/15/23 09:30 AM',
      action: null
    },
    {
      label: 'Processing',
      description: 'Your application is being reviewed by our team',
      icon: <Settings />,
      time: '10/18/23 02:15 PM',
      action: null
    },
    {
      label: 'Rejected',
      description: 'Unfortunately, your application has been rejected. Please contact support for details.',
      icon: <Close />,
      time: '10/20/23 01:00 PM',
      action: 'Contact Support'
    },
    {
      label: 'Approved',
      description: 'Your application has been approved! Next steps will be communicated soon',
      icon: <Verified />,
      time: '10/22/23 11:00 AM',
      action: 'View Approval Letter'
    },
    {
      label: 'Completed',
      description: 'Your application process is fully completed',
      icon: <DoneAll />,
      time: '10/25/23 04:30 PM',
      action: 'Download Certificate'
    }
  ];

  return (
    <Paper elevation={3} sx={{ maxWidth: 600, margin: 'auto', p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Description color="primary" sx={{ fontSize: 40, mr: 2 }} />
        <Box>
          <Typography variant="h5" component="div">
            Application Status
          </Typography>
        </Box>
      </Box>
      
      <Divider sx={{ my: 2 }} />
      
      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map((step, index) => (
          <Step key={step.label} completed={index < activeStep}>
            <StepLabel 
              StepIconComponent={() => (
                <Avatar sx={{ 
                  bgcolor: index <= activeStep ? (step.label === 'Rejected' ? 'error.main' : '#4caf50') : 'grey.300',
                  color: 'white'
                }}>
                  {step.icon}
                </Avatar>
              )}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="subtitle1">{step.label}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {step.time}
                </Typography>
              </Box>
            </StepLabel>
            <StepContent>
              <Typography variant="body2" sx={{ mb: 2 }}>{step.description}</Typography>
              {step.action && (
                <Button 
                  variant="outlined" 
                  size="small"
                  sx={{ mt: 1 }}
                  disabled={index > activeStep}
                >
                  {step.action}
                </Button>
              )}
              {index < steps.length - 1 && <Divider sx={{ my: 1 }} />}
            </StepContent>
          </Step>
        ))}
      </Stepper>
      
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
        <Chip 
          icon={activeStep === 2 ? <Close /> : <Verified />}
          label={activeStep === steps.length - 1 ? 'Application Completed' : 
                activeStep === 2 ? 'Application Rejected' : 
                activeStep >= 3 ? 'Application Approved' : 'Application In Progress'}
          color={activeStep === 2 ? 'error' : activeStep === steps.length - 1 ? 'success' : 
               activeStep >= 3 ? 'primary' : 'warning'}
          variant="outlined"
          sx={{ px: 2 }}
        />
      </Box>
    </Paper>
  );
};

export default ApplicationStatusTracker;